import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';


// Services
import { ConfigService } from '..//configuration/config.service';
import { AuthService } from "..//auth/auth.service";


import { Observable } from 'rxjs/Observable';
import 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';


import { Configuration } from "app/shared/models/configuration";

@Injectable()
export class ApiService {


  /* Variable to hold the  configuration file settings */
  private configuration: Configuration;

  constructor(private http: Http,
    private configService: ConfigService,
    private authservice: AuthService, ) {
    this.configuration = this.configService.getConfiguration();
  }




  Get(endPoint: string): Observable<any[]> {
    let headers = this.authservice.initAuthHeaders();
    return this.http
      .get(this.configuration.apiService + endPoint, { headers: headers })
      .map(this.handleData)
      .catch(this.handleError);
  }


  Create(endPoint: string, data: any): Observable<any> {
    let headers = this.authservice.initAuthHeaders();

    return this.http
      .post(this.configuration.apiService + endPoint, data, { headers: headers, })
      .map(this.handleData)
      .catch(this.handleError);
  }


  Update(endPoint: string, data: any): Observable<any> {
    let headers = this.authservice.initAuthHeaders();
    return this.http
      .put(this.configuration.apiService + endPoint, data, { headers: headers })
      .map(this.handleData)
      .catch(this.handleError);
  }


  Delete(endPoint: string, data: any): Observable<any> {

    let headers = this.authservice.initAuthHeaders();
    return this.http
      .delete(this.configuration.apiService + endPoint + '/' + data, { headers: headers })
      .map(this.handleData)
      .catch(this.handleError);

  }









  /* Data Handling */
  private handleData(res: Response) {
    let response = res.json();
    return response;
  }
  /* Data Handling */

  /* Error Handling */
  private handleError(error: any) {
    if (error.status === 401) {
      return Observable.throw('Unauthorized');
    }
    else {
      let errMsg = (error.message) ? error.message :
        error.status ? `${error.status} - ${error.statusText}` : 'Server error';
      console.log("handleError ::: " + errMsg);
      return Observable.throw(error);

    }

  }
  /* Error Handling */
}

















  //  {

  //   let headers = this.authservice.initAuthHeaders();

  //   console.log(this.configuration.apiService + this.customerEndpoint);
  //   console.log(headers);

  //   headers.append("crossDomain", "true");
  //   headers.append("contentType", "application/json; charset=utf-8");
  //   headers.append("dataType", "json");

  //   headers.append('Access-Control-Allow-Headers', 'Content-Type');
  //   headers.append('Access-Control-Allow-Methods', 'POST');
  //   headers.append('Access-Control-Allow-Origin', '*');





// WEBPACK FOOTER //
// C:/Software Development/Devpark/biz-app/src/app/shared/services/api/api.service.ts